import PropTypes from 'prop-types'
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@components/ui/tooltip'

export const AdasTooltip = ({ title, children, placement = 'top', disableHoverListener, sx, ...props }) => {
  if (disableHoverListener) {
    return <>{children}</>
  }

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>{children}</TooltipTrigger>
        <TooltipContent side={placement} {...props}>
          {title}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}

AdasTooltip.propTypes = {
  title: PropTypes.node,
  children: PropTypes.node,
  placement: PropTypes.string,
  disableHoverListener: PropTypes.bool
}
